import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'

export const TextTitleDescription = ({
    as,
    title,
    titleSpacing,
    alignment = 'center',
    textStyle = 'display-large',
    weight = '600',
    color = 'text.default',
    childrenTextStyle = 'body-xlarge',
    childrenTextWeight = '400',
    childrenTextColor = 'text.default',
    textTransform = 'none',
    noMinHeight = false,
    ...props
}) => {
    return (
        <Box textAlign={alignment} textTransform={textTransform} {...props}>
            {title && (
                <Box
                    as={as}
                    textStyle={textStyle}
                    color={color}
                    fontWeight={weight}
                    mb={titleSpacing}
                >
                    {title}
                </Box>
            )}
            {props.children && (
                <Box
                    textStyle={childrenTextStyle}
                    fontWeight={childrenTextWeight}
                    color={childrenTextColor}
                    minHeight={
                        noMinHeight
                            ? 'auto'
                            : {
                                  base: 'initial',
                                  sm: remCalc(60),
                                  md: remCalc(80),
                                  lg: remCalc(100),
                                  xl: remCalc(60),
                              }
                    }
                >
                    {props.children}
                </Box>
            )}
        </Box>
    )
}

TextTitleDescription.propTypes = {
    as: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    titleSpacing: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    alignment: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    textStyle: PropTypes.string,
    weight: PropTypes.string,
    color: PropTypes.string,
    childrenTextStyle: PropTypes.string,
    childrenTextWeight: PropTypes.string,
    childrenTextColor: PropTypes.string,
    textTransform: PropTypes.string,
    noMinHeight: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}
